import { useMutation } from '@tanstack/react-query';

import { prophetTypes } from '../types';
import { replaceMessagesWithUploadedFiles } from '../utils';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const editProphetRule: prophetTypes.EditProphetRule = async (data, pageId) => {
  const messagesWithUrls = await replaceMessagesWithUploadedFiles(data.messages, pageId);
  return axios.patch(`/prophet/rules`, { ...data, messages: messagesWithUrls });
};

type EditProphetRuleOptions = {
  pageId: string;
  config?: MutationConfig<typeof editProphetRule>;
};

export function useEditProphetRule({ config = {}, pageId }: EditProphetRuleOptions) {
  return useMutation({
    ...config,
    onMutate: (...args) => {
      toasts.loadingToast.loading('edit-prophet-rule');
      config.onMutate?.(...args);
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['prophet-rules', pageId]);
      toasts.loadingToast.success('edit-prophet-rule');
      config.onSuccess?.(...args);
    },
    onError: (...args) => {
      toasts.loadingToast.error('edit-prophet-rule');
      config.onError?.(...args);
    },
    mutationFn: (data) => editProphetRule(data, pageId),
  });
}
